import styles from "./index.module.scss";
import classNames from "classnames";
import MainTitle from "@/components/MainTitle";
import TitleWhithLine from "@/components/TitleWhithLine";
import { Col, Row,Tooltip } from "antd";
import intl from "react-intl-universal";
import icon_unit from "@/assets/images/home/icon_unit.png";
import icon_user from "@/assets/images/home/icon_user.png";
import icon_community from "@/assets/images/home/icon_community.png";
import CreateResource from '@/components/CreateResource';
import { useState } from "react";
const Join = () => {
  const [modalOpen,setModalOpen] = useState(false)
  const list = [
    // {
    //   title: "Members",
    //   text: "Members des",
    //   searchText: "BECOME A MEMBER",
    //   color: "#b1fbde",
    //   link: "about/member-listing",
    //   icon: icon_unit,
    // },
    {
      title: "Contributors",
      // secondTitle: 'Looking to get involved?',
      text: "Contributors des",
      searchText: "START CONTRIBUTING",
      color: "#bed8fe",
      link: "discover/share",
      icon: icon_community,
    },
    {
      title: "Community Users",
      // secondTitle: 'Using cloud native technologies?',
      text: "Community Users des",
      searchText: "JOIN THE COMMUNITY",
      color: "#e2befe",
      link: "register",
      icon: icon_user,
    },
  ];
  const linkTo = (item)=>{
    if (item.title === 'Contributors') {
      setModalOpen(true)
    }else{
      window.location.href = `${process.env.PUBLIC_URL}/${item.link}`
    }

  }
  return (
    <div className={classNames("container", styles.joinBox)}>
      {/* <MainTitle title="Home.You can become" /> */}
      <CreateResource setModalOpen={setModalOpen} modalOpen={modalOpen} />
      <h1 style={{textAlign:"center"}}>
        {intl.get("Home.You can become")}
      </h1>
      <Row gutter={40} align="stretch" style={{ marginTop: "120px" }}>
        {list.map((item, index) => {
          return (
            <Col
              span={12}
              key={index + "_join"}
              className={classNames(styles.joinItem, "wow animate__fadeInUp")}
              data-wow-duration={`${index * 0.5}s`}
            >
              <div>
                <div className={styles.tabCard}>
                  <p>{intl.get(`Home.${item.title}`)}</p>
                  <span></span>
                </div>
                <div className={styles.tabBox}>
                  <div>
                    <div
                      className={classNames(
                        styles.iconWrap,
                        "flex_box",
                        "align_center",
                        "flex_center"
                      )}
                    >
                      <img src={item.icon} alt="" />
                    </div>
                    <div className={styles.contentBox}>
                      <div>
                        {intl.get(`Home.${item.text}`)}
                        {/* <Tooltip title={intl.get(`Home.${item.text}`)}>
                        </Tooltip> */}
                       </div>
                    </div>
                    <div className={classNames(styles.titleLine,"flex_box","flex_center")}>
                      {/* <TitleWhithLine
                        link={item.link}
                        title={item.searchText}
                      /> */}
                      <a onClick={()=>linkTo(item)} href="#">{intl.get(item.searchText)}→</a>
                    </div>
                  </div>
                </div>
                {/* <div className={styles.titleBox} style={{ background: item.color }}>{intl.get(`Home.${item.title}`)}</div>
                            <div className={styles.contentBox}>
                                <div>{intl.get(`Home.${item.text}`)}</div>
                            </div>
                            <div className={styles.titleLine}>
                                <TitleWhithLine link={item.link} title={item.searchText} />
                            </div> */}
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};
export default Join;
